import { render, staticRenderFns } from "./ai_generator.vue?vue&type=template&id=bbccdb52"
import script from "./ai_generator.vue?vue&type=script&lang=js"
export * from "./ai_generator.vue?vue&type=script&lang=js"
import style0 from "./ai_generator.vue?vue&type=style&index=0&id=bbccdb52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports